import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

// Generic modal dismiss controller.
// Usage:
// - Inside a modal: data-action="click->dismiss-modal#close"
// - Specific modal: data-dismiss-modal-selector-value="#myModal"
export default class extends Controller {
  static values = {
    selector: String,
  }

  close() {
    const modalElement = this.selectorValue
      ? document.querySelector(this.selectorValue)
      : this.element.closest('.modal')

    if (!modalElement) return

    Modal.getOrCreateInstance(modalElement).hide()
  }
}
